import { IFinanceAlert, IParsedInvoiceAlert } from "./financeAlerts.types";

export const FINANCE_ALERT_TITLE = {
  APPROVED: "Invoice Approved",
  REJECTED: "CLP Rejected Invoice",
  LEGACY_REJECTED: "Invoice Rejected",
  SCANS_APPROVED: "Invoice Scans Approved",
  SCANS_REJECTED: "Invoice Scans Rejected",
  REGENERATED: "New Invoice Generated",
} as const;

export type TFinanceAlertKind =
  | "approved"
  | "rejected"
  | "scansApproved"
  | "scansRejected"
  | "regenerated"
  | "other";

const KIND_BY_TITLE: Record<string, TFinanceAlertKind> = {
  [FINANCE_ALERT_TITLE.APPROVED]: "approved",
  [FINANCE_ALERT_TITLE.REJECTED]: "rejected",
  [FINANCE_ALERT_TITLE.LEGACY_REJECTED]: "rejected",
  [FINANCE_ALERT_TITLE.SCANS_APPROVED]: "scansApproved",
  [FINANCE_ALERT_TITLE.SCANS_REJECTED]: "scansRejected",
  [FINANCE_ALERT_TITLE.REGENERATED]: "regenerated",
};

export const getAlertKind = (alert: Pick<IFinanceAlert, "title">): TFinanceAlertKind =>
  KIND_BY_TITLE[alert.title] ?? "other";

export const isRejectedAlert = (alert: Pick<IFinanceAlert, "title">) => {
  const kind = getAlertKind(alert);
  return kind === "rejected" || kind === "scansRejected";
};

export const isApprovedAlert = (alert: Pick<IFinanceAlert, "title">) => {
  const kind = getAlertKind(alert);
  return kind === "approved" || kind === "scansApproved" || kind === "regenerated";
};

const INVOICE_NUMBER_PATTERN =
  /invoice\s+(\S+?)\s+(?:was|were|has\s+been|have\s+been)\s+(?:approved|rejected)\b/i;
const REASON_PATTERN = /^Rejection reason\s*-\s*(.+)$/im;
const LEGACY_REASON_PATTERN = /\bReason:\s*([\s\S]+)$/i;
const DETAILS_PATTERN = /^Rejection Details\s*-\s*(.+)$/im;
const REVIEW_NOTES_PATTERN = /^Review notes\s*-\s*(.+)$/im;
const REMARKS_PATTERN = /^Vendor remarks\s*-\s*(.+)$/im;

export const parseInvoiceAlert = (subject: string | undefined): IParsedInvoiceAlert => {
  const text = subject ?? "";
  const invoiceNumber = INVOICE_NUMBER_PATTERN.exec(text)?.[1] ?? null;
  const reason =
    (REASON_PATTERN.exec(text) ?? LEGACY_REASON_PATTERN.exec(text))?.[1]?.trim() || null;
  const details =
    (DETAILS_PATTERN.exec(text) ??
      REVIEW_NOTES_PATTERN.exec(text) ??
      REMARKS_PATTERN.exec(text))?.[1]?.trim() || null;
  return { invoiceNumber, reason, details };
};
